import React from 'react';

function Label({ additionalClasses, children, ...rest }) {

    const className = "block text-gray-darkest font-semibold my-1 " + additionalClasses;

    return (
        <label className={className} {...rest}>{children}</label>
    );
}

export default Label;
